"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var MzSpinnerComponent = (function () {
    function MzSpinnerComponent() {
    }
    return MzSpinnerComponent;
}());
MzSpinnerComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'mz-spinner',
                template: "<div class=\"preloader-wrapper active {{ size }}\"><div class=\"spinner-layer\" [class.spinner-red-only]=\"color === 'red'\" [class.spinner-green-only]=\"color === 'green'\" [class.spinner-blue-only]=\"color === 'blue'\" [class.spinner-yellow-only]=\"color === 'yellow'\"><div class=\"circle-clipper left\"><div class=\"circle\"></div></div><div class=\"gap-patch\"><div class=\"circle\"></div></div><div class=\"circle-clipper right\"><div class=\"circle\"></div></div></div></div>",
                styles: [""],
            },] },
];
/** @nocollapse */
MzSpinnerComponent.ctorParameters = function () { return []; };
MzSpinnerComponent.propDecorators = {
    'color': [{ type: core_1.Input },],
    'size': [{ type: core_1.Input },],
};
exports.MzSpinnerComponent = MzSpinnerComponent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-materialize/dist/spinner/spinner.component.js
// module id = ./node_modules/ng2-materialize/dist/spinner/spinner.component.js
// module chunks = vendor